













/* General */
import Vue from 'vue'

/* Mixins */

/* Components */
import DashboardGridListToggle from '@/screens/dashboard/components/dashboard-grid-list-toggle.vue'
import SleekFilterInput from '@/components/global/inputs/sleek-filter-input.vue'

/* Helpers */

/* Data types */

/* API */

export default Vue.extend({
  name: 'DashboardHeader',
  components: {
    DashboardGridListToggle,
    SleekFilterInput,
  },
  props: {
    viewType: {
      type: String,
      required: true,
    },
    searchQuery: {
      type: String,
      required: true,
    },
  },
  computed: {
    internalViewType: {
      get(): any {
        return this.viewType
      },
      set(newValue: any) {
        this.$emit('update-view-type', newValue)
      },
    },
    internalSearchQuery: {
      get(): any {
        return this.searchQuery
      },
      set(newValue: any) {
        this.$emit('update:searchQuery', newValue)
      },
    },
  },
})
